
import { Component, Vue } from 'vue-property-decorator'
import Swiper, { SwiperOptions } from 'swiper'
import { Autoplay } from 'swiper/js/swiper.esm'
import { TABLET_PORTRAIT_WIDTH } from '../helpers/constants'

@Component({})
export default class AutoSwiper extends Vue {
  swiper: Swiper | null = null

  swiperOptions: SwiperOptions = {
    spaceBetween: 20,
    slidesPerView: 'auto',
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    breakpoints: {
      [TABLET_PORTRAIT_WIDTH]: { // bigger than tablet portrait
        spaceBetween: 40
      }
    }
  }

  swiperUsp: SwiperOptions = {
    slidesPerView: 'auto',
    loop: true,
    autoplay: {
      delay: 5000
    },

    breakpoints: {
      [TABLET_PORTRAIT_WIDTH]: { // bigger than tablet portrait
        slidesPerView: 3,
        autoplay: false,
        loop: false
      }
    }
  }

  get showNavigation(): boolean {
    return !(this.swiper?.isBeginning && this.swiper?.isEnd)
  }

  mounted() {
    this.$nextTick(() => {
      const swiper = (this.$refs.swiper as any).$swiper as Swiper
      this.swiper = swiper
    })
  }
}
